"use client";
import Image from "next/image";
import { FC, useContext, useEffect, useState } from "react";
import MaxWidthWrapper from "./MaxWidthWrapper";
import { FileMaker } from "./FileMaker";
import JWTContext from "./JWTProvider";
import {
  ArchiveIcon,
  AreaChartIcon,
  EyeIcon,
  ListIcon,
  PlusIcon,
} from "lucide-react";

import Link from "next/link";
import { getUserFromSession, validateUserData } from "../lib/userUtils";

const MainContent = () => {
  const [user, setUser] = useState<any>();
  const [meetings, setMeetings] = useState<any>([]);
  const [hasFutureMeetings, setHasFutureMeetings] = useState(false);
  const [loading, setLoading] = useState(true);
  const { JWT } = useContext(JWTContext);


    const loadMeetings = async () => {
      const meetings = await new FileMaker(JWT).getBoardMeetings();
      if (meetings[0].fieldData["Meeting Date"] > new Date()) {
        setMeetings(meetings);
      }
      setLoading(false);
    };

    
 
  useEffect(() => {
    const userStr = sessionStorage.getItem("userData");
    if (userStr) {
    const parsedUser = JSON.parse(userStr);
    setUser(parsedUser);
    }
    if (JWT === "") return;
    loadMeetings();
  }, [setUser, JWT]);

  return (
    <MaxWidthWrapper>
      <div className="flex flex-col p-10">
        <img
          src="https://www.cms.org/wp-content/uploads/2025/02/central-line-1.png"
          alt="Logo"
          className="w-1/3"
        />
        <div className="p-4">
          {/* <div className="bg-red-100 text-red-800 p-4 border border-red-200 rounded mb-4">
            <p>
              We do not have an email address on file for you. To effectively
              use the Central Line policy forum an email address is required.
              Please take a moment and{" "}
              <a href="#" className="text-blue-500 underline">
                update your email address
              </a>
              .
            </p>
          </div> */}
          
          <div className="border border-gray-300 p-4 rounded mb-4">

                <h1 className="text-xl font-bold mb-2">
                  Central Line: Your voice in Colorado health care from anywhere, anytime 
                </h1>
                Central Line gives you a direct connection to your Colorado Medical Society and the broader health care policy environment Colorado. This groundbreaking electronic platform—created by physicians, for physicians—enables you to contribute meaningful policy solutions and action initiatives anytime, anywhere. 
                
                As a CMS member, you can: 
                <ul className="list-disc list-inside my-4">  
                   <li>Submit policy and action initiative proposals directly to the CMS board of directors</li> 
                   <li>Provide feedback on colleagues&apos; proposals, influencing board decisions</li> 
                   <li>Share your perspective before and after critical votes 
                Central Line puts the powerful advocacy weight of Colorado Medical Society at your fingertips 24/7, accessible from any device. Your clinical expertise and frontline insights can drive meaningful change in Colorado&apos;s health care landscape.</li>
                </ul>
                <h1 className="text-xl font-bold mb-2">Make your voice heard. Your ideas matter.</h1> 
          </div>
          <div className="flex flex-col space-y-2 items-center">
            <Link
                href={user ? "/submit" : "/sign-in"}
                className="flex bg-teal-500 text-white py-2 px-4 rounded w-1/2 flex-row gap-2 items-center justify-center font-semibold"
              ><PlusIcon size={20} />
                 Submit Proposal
            </Link>  
            <Link
              href={user ? "/current-proposals" : "/sign-in"}
              className="flex flex-row gap-2 justify-center font-semibold bg-blue-500 text-white py-2 px-4 rounded w-1/2"
            >
              <ListIcon size={20} />
              Current Proposals
            </Link>
            <Link
              href={user ? "/my-proposals" : "/sign-in"}  className="flex flex-row gap-2 justify-center font-semibold bg-indigo-500 text-white py-2 px-4 rounded w-1/2">
              <EyeIcon size={20} />
              My Proposals
            </Link>

            {
              Array.isArray(meetings) && meetings.length > 0 ? (
                (() => {
                  const latestMeeting = meetings
                    .filter(meeting => meeting.fieldData["Meeting Date"]) // Ensure date exists
                    .sort((a, b) => {
                      const dateA = new Date(a.fieldData["Meeting Date"]).getTime();
                      const dateB = new Date(b.fieldData["Meeting Date"]).getTime();
                      return dateB - dateA;
                    })[0];

                  return latestMeeting ? (
                    <Link href={user ? `/board-summaries/${meetings[0].fieldData["ID"]}` : "/sign-in"} className="flex flex-row gap-2 justify-center font-semibold bg-red-500 text-white py-2 px-4 rounded w-1/2">
                    <ArchiveIcon size={20} />
                    {new Date(latestMeeting.fieldData["Meeting Date"]).toLocaleDateString(
                                    "en-US",
                                    {
                                      year: "numeric",
                                      month: "long",
                                      day: "numeric",
                                    }
                                  )}
                    </Link>
                  ) : (<></>
                  );
                })()
              ) : (<></>)}      
            
            <Link href={user ? "/board-summaries" : "/sign-in"} className="flex flex-row gap-2 justify-center font-semibold bg-gray-500 text-white py-2 px-4 rounded w-1/2">
              <ArchiveIcon size={20} />
              Board Summary Archive
            </Link>

          </div>
        </div>
      </div>
    </MaxWidthWrapper>
  );
};

export default MainContent;
